import { render } from "./ReturnDownloadForm.vue?vue&type=template&id=6da0a05b&scoped=true&ts=true"
import script from "./ReturnDownloadForm.vue?vue&type=script&lang=ts"
export * from "./ReturnDownloadForm.vue?vue&type=script&lang=ts"

import "./ReturnDownloadForm.vue?vue&type=style&index=0&id=6da0a05b&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6da0a05b"]])

export default __exports__